import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { MedioPagoVentasSelect } from 'sharedComponents/select'

const MedioPago3FormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Col md={12}>
        <Field name='medioPago3'>
          {({ field }) => <MedioPagoVentasSelect {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='input-medioPago3' />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(MedioPago3FormGroup)
